(function () {
  'use strict';

  const KEY = 'lcViewedHandles';
  const MAX = 4;

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function pushHandle(handle) {
    if (!handle) return;
    let list = getHandles().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    list = list.slice(0, MAX + 1);
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  window.lcTrackViewedProduct = pushHandle;

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return '₹' + (cents / 100).toFixed(0);
  }

  async function renderSection(section) {
    const grid = section.querySelector('[data-lc-recent-grid]');
    const current = section.getAttribute('data-current-handle');
    if (!grid) return;

    const handles = getHandles().filter(function (h) {
      return h && h !== current;
    }).slice(0, MAX);

    if (!handles.length) {
      section.hidden = true;
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    grid.innerHTML = '';

    for (const handle of handles) {
      try {
        const res = await fetch(root + 'products/' + handle + '.js');
        if (!res.ok) continue;
        const product = await res.json();
        const img = product.images[0];
        const card = document.createElement('article');
        card.className = 'lc-hp-card lc-pdp-recent__card';
        card.innerHTML =
          '<a href="' +
          root +
          'products/' +
          handle +
          '" class="lc-hp-card__img-link">' +
          (img
            ? '<img src="' +
              img +
              '" alt="' +
              (product.title || '').replace(/"/g, '&quot;') +
              '" loading="lazy" class="lc-hp-card__img--primary">'
            : '<span class="lc-hp-card__gem"></span>') +
          '</a><div class="lc-hp-card__meta"><h3 class="lc-hp-card__title"><a href="' +
          root +
          'products/' +
          handle +
          '">' +
          product.title +
          '</a></h3><div class="lc-hp-card__price-row"><span>' +
          formatMoney(product.price) +
          '</span></div></div>';
        grid.appendChild(card);
      } catch (_) {
        /* skip */
      }
    }

    if (!grid.children.length) section.hidden = true;
  }

  document.querySelectorAll('[data-lc-recent-section]').forEach(renderSection);
})();
